var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42578 20.3105C5.42578 28.6639 12.1975 35.4355 20.5508 35.4355C28.9041 35.4355 35.6758 28.6639 35.6758 20.3105C35.6758 11.9572 28.9041 5.18555 20.5508 5.18555C12.1975 5.18555 5.42578 11.9572 5.42578 20.3105Z",
    fill: "#08C108"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5924 16.9494L18.8702 23.6717L15.5091 20.3105M20.5508 35.4355C12.1975 35.4355 5.42578 28.6639 5.42578 20.3105C5.42578 11.9572 12.1975 5.18555 20.5508 5.18555C28.9041 5.18555 35.6758 11.9572 35.6758 20.3105C35.6758 28.6639 28.9041 35.4355 20.5508 35.4355Z",
    stroke: "white",
    strokeWidth: 1.68056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/Circle_Check.09d94811c6be46f6848aa4065873effe.svg";
export { ForwardRef as ReactComponent };